import { render, staticRenderFns } from "./StoreGoodsDisplay.vue?vue&type=template&id=476f31f4&scoped=true"
import script from "./StoreGoodsDisplay.vue?vue&type=script&lang=js"
export * from "./StoreGoodsDisplay.vue?vue&type=script&lang=js"
import style0 from "./StoreGoodsDisplay.vue?vue&type=style&index=0&id=476f31f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f31f4",
  null
  
)

export default component.exports